import { IQService } from "angular";
import { getExceptionMessage } from "../../core/data-utils";
import { EmploymentProcessingService } from "../../core/services";
import { ProcessingState, TerminationVM } from "./employment-processing-models";

export class TerminationsProcessor {
    constructor(private $q: IQService, private employmentProcessingService: EmploymentProcessingService) {
        'ngInject';
    }

    batchProcessTermination(terminations: TerminationVM[]) {
        const chunkResult = terminations.reduce((processingResult, employee) => {
            employee.processingState = ProcessingState.Processing;
            const saved = this.employmentProcessingService.processTermination(employee.EmployeeID)
                .then(() => {
                    employee.processingState = ProcessingState.Processed;
                    employee.isSelected = false;
                    processingResult.succeeded++;
                })
                .catch(ex => {
                    employee.processingState = ProcessingState.Failed;
                    processingResult.failed++;
                    processingResult.messages.push(`failed to process ${employee.EmployeeID}: `
                        + getExceptionMessage(ex));
                });
            processingResult.promises.push(saved);
            return processingResult;
        }, { succeeded: 0, failed: 0, messages: [], promises: [] });
        return this.$q.all(chunkResult.promises)
            .then(() => chunkResult);
    }
}
